// extracted by mini-css-extract-plugin
export default {"container":"top-banner-module__container___gvM57"};